import React, { useState, useRef, useEffect } from 'react';
import { getMetas, createMeta, updateMeta, softDeleteMeta } from '../../Services/MetaService';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import Overlay from '../../Components/Overlay/Overlay';
import { handlerFormError, uuid } from '../../Utils/Utils';
import EditButton from '../../Components/Button/EditButton';
import { useDispatch } from 'react-redux';
import { setModuleName } from '../../Stores/Action/AppAction';

let processingId = -1;

const MetaScreen = () => {
    const mTable = useRef();
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, setValue, control, formState: { errors } } = useForm({
        defaultValues: {
            meta: '',
            meta_function: '',
            meta_description: '',
            meta_value: '',
            meta_unit: '',
            meta_active_msg: '',
            meta_archive_msg: '',
            is_active: true
        }
    });

    const [state, setState] = useState({
        showForm: false,
        meta: {
            meta_name: '',
            is_active: true
        },
        units: ['seconds','minutes', 'hours', 'hours', 'days', 'months'],
        processing: false
    });

    useEffect(() => {
        dispatch(setModuleName('Meta'));
    }, []);

    const changeStatus = (username, status) => {
        const body = {
            is_active: status
        }

        softDeleteMeta(username, body, res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Change status success',
                    text: 'Data has been changed!'
                }).then(res => { mTable.current.refresh(); });
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Change status fail',
                text: 'Data can not be changed!'
            });
        });
    }

    const columns = [
        { id: uuid(), title: 'Meta Name', field: 'meta', sortable: true },
        { id: uuid(), title: 'Description', field: 'meta_description', sortable: true },
        {
            id: uuid(),
            title: 'Data',
            field: 'meta_table',
            sortable: false,
            render: data => {
              return <div>
                <span><b>Storage Periode :</b> </span><span>{ data.meta_table.amount }  { data.meta_table.unit }</span><br/>
                <span><b>Active files Label :</b> </span><span>{ data.meta_table.active_file_message }</span><br/>
                <span><b>Archive trash bin Label :</b> </span><span>{ data.meta_table.archive_trash_message }</span><br/>
              </div>;
            },
        },
        {
            id: uuid(),
            title: 'Active',
            field: 'is_active',
            sortable: true,
            options: [
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ],
            render: data => {
              return data.is_active ? 'Active' : 'In-Active';
            },
        },
        {
            id: uuid(),
            title: 'Action',
            sortable: false,
            style: { width: 200 },
            render: item => {
                return item.is_active && (
                    <div>
                        <EditButton title="Edit" onClick={onEdit(item)} />
                    </div>);
            },
        },
    ];

    const propsTable = { columns, getData: getMetas, enableMeta: true, showAddButton: false, metaRule: 'meta' };


    const onEdit = item => () => {
        reset(item);
        setValue('meta_value', item.meta_table.amount);
        setValue('meta_unit', item.meta_table.unit);
        setValue('meta_active_msg', item.meta_table.active_file_message);
        setValue('meta_archive_msg', item.meta_table.archive_trash_message);
        setState({ ...state, meta: item, showForm: true });
    }

    const onAddData = () => {
        onReset();
        setState({ ...state, showForm: true });
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onSubmit = (data) => {
        startProcessing();
        // const formData = new FormData();
        // let arr = {};

        // for (var key in data) {
        //     if(key == 'meta_value'){
        //         arr['amount'] = data[key]
        //     }else if(key == 'meta_unit'){
        //         arr['unit'] = data[key]
        //     }else if(key == 'meta_active_msg'){
        //         arr['active_file_message'] = data[key]
        //     }else if(key == 'meta_archive_msg'){
        //         arr['archive_trash_message'] = data[key]
        //     }else{
        //         formData.append(key, data[key]);
        //     }  
        // }
        
        // formData.append('meta_table', arr);
        // formData.append('is_active', 1);


        //const response = meta._id ? updateMeta(meta._id.$oid, formData) : createMeta(formData);

        const response = meta._id ? updateMeta(meta._id.$oid, data) : createMeta(data);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    mTable.current.refresh();
                    meta._id ? onCloseForm() : onReset();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        reset({
            meta: '',
            meta_function: '',
            meta_description: '',
            meta_value: '',
            meta_unit: '',
            meta_active_msg: '',
            meta_archive_msg: '',
            is_active: true
        });
        setState({ ...state, meta: {} });
    }

    const onCloseForm = () => {
        reset({
            meta: '',
            meta_function: '',
            meta_description: '',
            meta_value: '',
            meta_unit: '',
            meta_active_msg: '',
            meta_archive_msg: '',
            is_active: true
        });
        setState({ ...state, meta: {}, showForm: false });
    }

    const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ""

    const { meta, units, processing, showForm } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <div className="card-header">
                                    <div className="card-title">
                                        <i className="fas fa-tags mr-1" />
                                        {showForm ? ' Form Asset Meta' : ' List Asset Meta'}
                                    </div>
                                </div>

                                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-body'>
                                        <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                                            <MTable ref={mTable} {...propsTable} onAddData={onAddData} showIndex={true} />
                                        </div>

                                        <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                                            <div className='row'>
                                                <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label htmlFor="meta" className='mandatory'>Meta Name</label>
                                                        <input id="meta" {...register("meta", { required: { value: true, message: 'Asset meta name is required!' } })} placeholder='Asset meta name' className='form-control' readOnly={true} style={{ background: `#e9ecef` }} />
                                                        {errors.meta && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.meta.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="meta_function" className=''>Meta Function</label>
                                                        <input id="meta_function" {...register("meta_function")} placeholder='Asset meta name' className='form-control' />
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="meta_description" className=''>Meta Description</label>
                                                        <input id="meta_description" {...register("meta_description")} placeholder='Asset meta name' className='form-control' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group row' style={{ paddingTop: 30 }}>
                                                        <div className='col-md-6'>
                                                            <label htmlFor="meta_value" className='mandatory'>Meta Value</label>
                                                            <input id="meta_value" {...register("meta_value", { required: { value: true, message: 'Asset meta name is required!' } })} placeholder='Meta value' className='form-control' type="number" />
                                                            {errors.meta_value && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.meta_value.message}</span>)}
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label htmlFor="meta_unit" className='mandatory'>Meta Unit</label>
                                                            <select id="meta_unit" className='form-control' {...register("meta_unit", { required: 'Meta unit is required!' })}>
                                                                <option value="-1" >-- Select Unit --</option>
                                                                {units?.map((item, i) => <option key={`meta-unit-${i}`} value={item} >{capitalize(item)}</option>)}
                                                            </select>
                                                            {errors.meta_unit && <span className='text-danger'>{errors.meta_unit.message}</span>}
                                                        </div>
                                                        
                                                    </div>  
                                                    <div className='form-group'>
                                                        <label htmlFor="meta_active_msg" className='mandatory'>Active Files Label</label>
                                                        <input id="meta_active_msg" {...register("meta_active_msg", { required: { value: true, message: 'Meta active file label is required!' } })} placeholder='Active file label' className='form-control' />
                                                        {errors.meta_active_msg && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.meta_active_msg.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="meta_archive_msg" className='mandatory'>Archive Trash Bin Label</label>
                                                        <input id="meta_archive_msg" {...register("meta_archive_msg", { required: { value: true, message: 'Meta archive label is required!' } })} placeholder='Archive trash bin label' className='form-control' />
                                                        {errors.meta_archive_msg && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.meta_archive_msg.message}</span>)}
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        showForm && <div className='card-footer delay'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onCloseForm}><i className='fa fa-times' /> Close</button>
                                                        <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-sync' /> Clear</button>
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }}
                                                        >
                                                            <i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MetaScreen;